import { StoreSchema } from '../../types/store'
import { createSelector } from 'reselect'

export const selectAllProductsUtcOffset = (store: StoreSchema) =>
    store.productsUtcOffset

export const selectOneProductUtcOffset = (guid: string) =>
    createSelector([selectAllProductsUtcOffset], (state) => state[guid])
